import { setToken, deleteToken, clearAll } from "../../utils/token";

import { purgeStoredState } from "redux-persist";
import storage from "redux-persist/lib/storage";

// Action Types
export const actionTypes = {
  REMOVE_TOAST: "REMOVE_TOAST",

  AUTH_CHECK: "AUTH_CHECK",
  AUTH_LOGIN: "AUTH_LOGIN",
  AUTH_LOGOUT: "AUTH_LOGOUT",

  AUTH_REFRESH_TOKEN: "AUTH_REFRESH_TOKEN",
  AUTH_RESET_PASSWORD: "AUTH_RESET_PASSWORD",
  AUTH_USER: "AUTH_USER",

  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILED: "LOGIN_FAILED",

  LOGOUT_REQUEST: "LOGOUT_REQUEST",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_FAILED: "LOGOUT_FAILED",

  FORGOT_PASSWORD: "FORGOT_PASSWORD",
  FORGOT_PASSWORD_SUCCESS: "FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_FAILED: "FORGOT_PASSWORD_FAILED",

  GET_AUTH: "GET_AUTH",
  GET_AUTH_SUCCESS: "GET_AUTH_SUCCESS",
  GET_AUTH_FAILED: "GET_AUTH_FAILED"
};

// Action creators
export const actionCreators = {
  removeToast: () => ({ type: actionTypes.REMOVE_TOAST }),
  login: body => ({ type: actionTypes.LOGIN_REQUEST, body }),
  logout: id => ({ type: actionTypes.LOGOUT_REQUEST, id }),
  forgot: body => ({ type: actionTypes.FORGOT_PASSWORD, body }),
};

// Reducer
const initialState = {
  isAuthenticated: false,
  isLoading: false,
  accessToken: null,
  errors: null,
  profile: null,
  toast: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REMOVE_TOAST:
      return Object.assign({}, state, { toast: null });
    case actionTypes.LOGOUT_REQUEST:
    case actionTypes.LOGIN_REQUEST:
    case actionTypes.FORGOT_PASSWORD:
      return Object.assign({}, state, {
        isLoading: true,
        errors: null
      });
    case actionTypes.LOGIN_SUCCESS:
      setToken(action.payload.data.token.access_token);
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        isAuthenticated: true,
        accessToken: action.payload.data.token.access_token,
        profile: {
          id: action.payload.data.id,
          name: {
            fullname: action.payload.data.full_name,
            first_name: action.payload.data.first_name,
            middle_name: action.payload.data.middle_name,
            last_name: action.payload.data.last_name,
          },
          type: action.payload.data.type,
          email: action.payload.data.email,
          mobile_number: action.payload.data.mobile_number
        }
      });
    case actionTypes.FORGOT_PASSWORD_SUCCESS:
      console.log("SUCCESS", action)
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        toast: { type: "success", message: "Password reset link is sent" }
      })

    case actionTypes.LOGOUT_SUCCESS:
      const persistConfig = { key: "root", storage };
      const authPersistConfig = { key: "auth", storage };
      purgeStoredState(persistConfig);
      purgeStoredState(authPersistConfig);
      deleteToken();
      clearAll();
      return Object.assign({}, state, {
        isLoading: false,
        isAuthenticated: false,
        profile: null,
        accessToken: null
      });

    case actionTypes.LOGOUT_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        isAuthenticated: false,
        accessToken: null
      });
    case actionTypes.LOGIN_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        toast: { type: "failed", message: action.payload.error },
        isAuthenticated: false,
        accessToken: null
      });
    case actionTypes.FORGOT_PASSWORD_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        toast: { type: 'failed', message: action.payload.error },
      })

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/auth/reducer.js